export default "__VITE_ASSET__BY$I50Sq__"